import { createBrowserRouter, RouterProvider, Outlet, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks';
import Layout from '@components/layout/Layout';
import AdminLayout from '@components/layout/AdminLayout';
import HomePage from '@pages/HomePage';
import EventsPage from '@pages/EventsPage';
import AboutPage from '@pages/AboutPage';
import AstronomersPage from '@pages/AstronomersPage';
import ArtistsPage from '@pages/ArtistsPage';
import RenovationPage from '@pages/RenovationPage';
import RecentPage from '@pages/RecentPage';
import AktionsbuendnisPage from '@pages/AktionsbuendnisPage';
import AboutUsPage from '@pages/AboutUsPage';
import LesezeichenPage from '@pages/LesezeichenPage';
import LiteraturPage from '@pages/LiteraturPage';
import PressePage from '@pages/PressePage';
import UnterstuetzenPage from '@pages/UnterstuetzenPage';
import ContactPage from '@pages/ContactPage';
import ImpressumPage from '@pages/ImpressumPage';
import DatenschutzPage from '@pages/DatenschutzPage';

// Admin pages
import AdminLogin from '@pages/admin/Login';
import AdminDashboard from '@pages/admin/Dashboard';
import EventsManage from '@pages/admin/EventsManage';
import BookingsManage from '@pages/admin/BookingsManage';
import ArticlesManage from '@pages/admin/ArticlesManage';

// Protected route wrapper for admin
function ProtectedAdminRoute() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-slate-400">Laden...</p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/admin/login" replace />;
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'termine', element: <EventsPage /> },
      { path: 'about', element: <AboutPage /> },
      { path: 'astronomen', element: <AstronomersPage /> },
      { path: 'kuenstler', element: <ArtistsPage /> },
      { path: 'renovierung', element: <RenovationPage /> },
      { path: 'erweiterungen', element: <RecentPage /> },
      { path: 'aktionsbuendnis', element: <AktionsbuendnisPage /> },
      { path: 'ueber-uns', element: <AboutUsPage /> },
      { path: 'lesezeichen', element: <LesezeichenPage /> },
      { path: 'literatur', element: <LiteraturPage /> },
      { path: 'presse', element: <PressePage /> },
      { path: 'unterstuetzen', element: <UnterstuetzenPage /> },
      { path: 'kontakt', element: <ContactPage /> },
      { path: 'impressum', element: <ImpressumPage /> },
      { path: 'datenschutz', element: <DatenschutzPage /> },
    ],
  },
  // Admin routes
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      { path: 'login', element: <AdminLogin /> },
      {
        element: <ProtectedAdminRoute />,
        children: [
          { index: true, element: <AdminDashboard /> },
          { path: 'events', element: <EventsManage /> },
          { path: 'bookings', element: <BookingsManage /> },
          { path: 'articles', element: <ArticlesManage /> },
        ],
      },
    ],
  },
], {
  basename: '/',
});

function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}

export default App;
